<template>
  <nav class="catalog-expendable-nav" :class="{
    'catalog-expendable-nav-retracted': !isInHomeScreen,
    'catalog-expendable-nav-extended': isInHomeScreen,
    'catalog-nav-scrolled': isNavScrolled && !isInHomeScreen
  }">


    <div class="nav-head">
      <button @click="$root.$emit('openSideNav')"><i class="material-icons notranslate">menu</i></button>
      <button @click="search"><i class="material-icons notranslate">search</i></button>
    </div>

    <div class="nav-illustration-container">
      <div class="nav-illustration">
        <div class="illustration__message">
          <svg width="197" height="160" viewBox="0 0 197 160" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="197" height="131" rx="15" fill="white"/>
            <g clip-path="url(#clip0)">
              <path d="M46.9443 160C46.9443 160 51.0219 147.06 50.0786 141.177C47.8572 127.232 28.8933 129.083 28.8933 129.083H50.7298H80.5572C80.5572 129.083 76.5283 139.258 69.3285 146.399C63.839 151.841 46.9443 160 46.9443 160Z" fill="white"/>
            </g>
            <path d="M26.798 17.9H21.32V41H27.029C30.659 41 32.54 39.086 32.54 35.522V33.641C32.54 31.199 31.781 29.45 29.834 28.691C31.451 27.932 32.177 26.414 32.177 24.038V23.213C32.177 19.649 30.56 17.9 26.798 17.9ZM26.567 30.605C28.217 30.605 28.91 31.265 28.91 33.41V35.423C28.91 37.139 28.25 37.7 27.029 37.7H24.95V30.605H26.567ZM26.699 21.2C27.986 21.2 28.547 21.926 28.547 23.576V24.863C28.547 26.711 27.722 27.305 26.369 27.305H24.95V21.2H26.699ZM34.7263 41H38.3563V17.9H34.7263V41ZM44.6404 21.2H50.9104V17.9H41.0104V41H50.9104V37.7H44.6404V30.935H49.6234V27.635H44.6404V21.2ZM60.9148 41H64.6438V17.9H61.4098V31.727L57.6808 17.9H53.1268V41H56.3938V24.269L60.9148 41ZM69.9489 17.9H66.2859L69.8499 41H75.2619L78.8259 17.9H75.4929L72.7209 36.743L69.9489 17.9ZM84.1502 21.2H90.4202V17.9H80.5202V41H90.4202V37.7H84.1502V30.935H89.1332V27.635H84.1502V21.2ZM100.425 41H104.154V17.9H100.92V31.727L97.1906 17.9H92.6366V41H95.9036V24.269L100.425 41ZM106.588 17.9V35.489C106.588 39.185 108.436 41.297 112 41.297C115.564 41.297 117.412 39.185 117.412 35.489V17.9H113.98V35.72C113.98 37.37 113.254 37.964 112.099 37.964C110.944 37.964 110.218 37.37 110.218 35.72V17.9H106.588ZM123.531 21.2H129.801V17.9H119.901V41H129.801V37.7H123.531V30.935H128.514V27.635H123.531V21.2ZM136.712 23.444C136.712 30.044 143.807 30.935 143.807 35.687C143.807 37.337 143.081 37.931 141.926 37.931C140.771 37.931 140.045 37.337 140.045 35.687V34.037H136.613V35.456C136.613 39.152 138.461 41.264 142.025 41.264C145.589 41.264 147.437 39.152 147.437 35.456C147.437 28.856 140.342 27.965 140.342 23.213C140.342 21.563 141.002 20.936 142.157 20.936C143.312 20.936 143.972 21.563 143.972 23.213V24.17H147.404V23.444C147.404 19.748 145.589 17.636 142.058 17.636C138.527 17.636 136.712 19.748 136.712 23.444ZM149.352 17.9V35.489C149.352 39.185 151.2 41.297 154.764 41.297C158.328 41.297 160.176 39.185 160.176 35.489V17.9H156.744V35.72C156.744 37.37 156.018 37.964 154.863 37.964C153.708 37.964 152.982 37.37 152.982 35.72V17.9H149.352ZM173.952 41C173.589 40.142 173.556 39.317 173.556 38.195V34.631C173.556 32.222 172.962 30.473 171.147 29.714C172.764 28.955 173.523 27.404 173.523 25.028V23.213C173.523 19.649 171.906 17.9 168.144 17.9H162.666V41H166.296V31.595H167.55C169.2 31.595 169.926 32.387 169.926 34.532V38.162C169.926 40.043 170.058 40.406 170.256 41H173.952ZM168.045 21.2C169.332 21.2 169.893 21.926 169.893 23.576V25.853C169.893 27.701 169.068 28.295 167.715 28.295H166.296V21.2H168.045Z" fill="#262C30"/>
            <path d="M22.72 113H27.958V111.2H24.7V100.4H22.72V113ZM33.2116 100.4H30.3136L28.2976 113H30.1156L30.4576 110.714H32.8876L33.2296 113H35.2276L33.2116 100.4ZM31.6636 102.632L32.6176 109.004H30.7096L31.6636 102.632ZM41.8606 100.4H38.9446V113H40.9246V108.266H41.8606C43.8406 108.266 44.8126 107.168 44.8126 105.152V103.514C44.8126 101.498 43.8406 100.4 41.8606 100.4ZM41.8606 102.2C42.4906 102.2 42.8326 102.488 42.8326 103.388V105.278C42.8326 106.178 42.4906 106.466 41.8606 106.466H40.9246V102.2H41.8606ZM45.8177 113H51.0557V111.2H47.7977V100.4H45.8177V113ZM56.3093 100.4H53.4113L51.3953 113H53.2133L53.5553 110.714H55.9853L56.3273 113H58.3253L56.3093 100.4ZM54.7613 102.632L55.7153 109.004H53.8073L54.7613 102.632ZM58.6713 102.2H60.7413V113H62.7213V102.2H64.7913V100.4H58.6713V102.2ZM67.6434 102.2H71.0634V100.4H65.6634V113H71.0634V111.2H67.6434V107.51H70.3614V105.71H67.6434V102.2ZM74.2703 102.2H77.5283V100.4H72.2903V113H74.2703V107.798H76.8263V105.998H74.2703V102.2ZM80.2958 103.298C80.2958 102.398 80.6918 102.056 81.3218 102.056C81.9518 102.056 82.3478 102.398 82.3478 103.298V110.102C82.3478 111.002 81.9518 111.344 81.3218 111.344C80.6918 111.344 80.2958 111.002 80.2958 110.102V103.298ZM78.3158 109.976C78.3158 111.992 79.3778 113.144 81.3218 113.144C83.2658 113.144 84.3278 111.992 84.3278 109.976V103.424C84.3278 101.408 83.2658 100.256 81.3218 100.256C79.3778 100.256 78.3158 101.408 78.3158 103.424V109.976ZM91.7705 113C91.5725 112.532 91.5545 112.082 91.5545 111.47V109.526C91.5545 108.212 91.2305 107.258 90.2405 106.844C91.1225 106.43 91.5365 105.584 91.5365 104.288V103.298C91.5365 101.354 90.6545 100.4 88.6025 100.4H85.6145V113H87.5945V107.87H88.2785C89.1785 107.87 89.5745 108.302 89.5745 109.472V111.452C89.5745 112.478 89.6465 112.676 89.7545 113H91.7705ZM88.5485 102.2C89.2505 102.2 89.5565 102.596 89.5565 103.496V104.738C89.5565 105.746 89.1065 106.07 88.3685 106.07H87.5945V102.2H88.5485ZM95.5927 100.4H92.8387V113H94.5667V104.09L96.0427 113H97.9147L99.2827 103.964V113H101.155V100.4H98.4007L97.0507 109.346L95.5927 100.4ZM104.575 102.2H107.995V100.4H102.595V113H107.995V111.2H104.575V107.51H107.293V105.71H104.575V102.2ZM113.997 102.2H117.417V100.4H112.017V113H117.417V111.2H113.997V107.51H116.715V105.71H113.997V102.2ZM114.879 97.736L113.655 99.734H114.987L116.823 97.736H114.879ZM118.482 109.976C118.482 111.992 119.544 113.144 121.488 113.144C122.01 113.144 122.478 113.054 122.874 112.91C123.144 113.45 123.702 113.774 124.584 113.774H124.854V112.01H124.674C124.35 112.01 124.206 111.974 124.116 111.74C124.368 111.272 124.494 110.678 124.494 109.976V103.424C124.494 101.408 123.432 100.256 121.488 100.256C119.544 100.256 118.482 101.408 118.482 103.424V109.976ZM120.462 103.298C120.462 102.398 120.858 102.056 121.488 102.056C122.118 102.056 122.514 102.398 122.514 103.298V110.102C122.514 111.002 122.118 111.344 121.488 111.344C120.858 111.344 120.462 111.002 120.462 110.102V103.298ZM125.691 100.4V109.994C125.691 112.01 126.699 113.162 128.643 113.162C130.587 113.162 131.595 112.01 131.595 109.994V100.4H129.723V110.12C129.723 111.02 129.327 111.344 128.697 111.344C128.067 111.344 127.671 111.02 127.671 110.12V100.4H125.691ZM132.952 113H134.932V100.4H132.952V113ZM135.804 102.2H137.874V113H139.854V102.2H141.924V100.4H135.804V102.2ZM146.503 100.4H143.605L141.589 113H143.407L143.749 110.714H146.179L146.521 113H148.519L146.503 100.4ZM144.955 102.632L145.909 109.004H144.001L144.955 102.632ZM152.429 100.4H149.441V113H152.555C154.535 113 155.561 111.956 155.561 110.012V108.986C155.561 107.654 155.147 106.7 154.085 106.286C154.967 105.872 155.363 105.044 155.363 103.748V103.298C155.363 101.354 154.481 100.4 152.429 100.4ZM152.303 107.33C153.203 107.33 153.581 107.69 153.581 108.86V109.958C153.581 110.894 153.221 111.2 152.555 111.2H151.421V107.33H152.303ZM152.375 102.2C153.077 102.2 153.383 102.596 153.383 103.496V104.198C153.383 105.206 152.933 105.53 152.195 105.53H151.421V102.2H152.375ZM156.753 113H161.991V111.2H158.733V100.4H156.753V113ZM164.833 102.2H168.253V100.4H162.853V113H168.253V111.2H164.833V107.51H167.551V105.71H164.833V102.2Z" fill="#262C30"/>
            <path d="M22.36 91H32.626C39.116 91 42.302 87.401 42.302 80.793V59.907C42.302 53.299 39.116 49.7 32.626 49.7H22.36V91ZM32.508 55.6C34.573 55.6 35.812 56.662 35.812 59.612V81.088C35.812 84.038 34.573 85.1 32.508 85.1H28.85V55.6H32.508ZM52.934 55.6H64.144V49.7H46.444V91H64.144V85.1H52.934V73.005H61.843V67.105H52.934V55.6ZM68.1657 91H85.3347V85.1H74.6557V49.7H68.1657V91ZM88.1588 91H94.6488V49.7H88.1588V91ZM112.079 75.601V81.501C112.079 84.451 110.781 85.513 108.716 85.513C106.651 85.513 105.353 84.451 105.353 81.501V59.199C105.353 56.249 106.651 55.128 108.716 55.128C110.781 55.128 112.079 56.249 112.079 59.199V63.624H118.215V59.612C118.215 53.004 114.911 49.228 108.539 49.228C102.167 49.228 98.8632 53.004 98.8632 59.612V81.088C98.8632 87.696 102.167 91.472 108.539 91.472C114.911 91.472 118.215 87.696 118.215 81.088V75.601H112.079ZM122.153 91H128.643V49.7H122.153V91ZM131.5 55.6H138.285V91H144.775V55.6H151.56V49.7H131.5V55.6ZM160.496 91H166.986V77.312L175.187 49.7H168.992L164.036 68.521L159.08 49.7H152.295L160.496 77.312V91Z" fill="#262C30"/>
            <defs>
              <clipPath id="clip0">
                <rect width="51.6578" height="31" fill="white" transform="translate(28.8933 129)"/>
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="illustration__bag">
          <img src="/img/bag.svg" alt="">
        </div>
      </div>
    </div>


    <div class="nav-container">
      <div class="nav-location-container">
        <div class="nav-location-icon-container">
          <div class="nav-location-icon">
            <i class="material-icons notranslate-outlined">place</i>
          </div>
        </div>
        <form @submit.prevent="parseAddress" class="nav-location">

          <div class="location__title">
            <span>Saisissez votre adresse pour voir les établissements à proximité</span>
            <small v-if="locationPermissionError" class="error">{{locationPermissionError}}</small>
          </div>
          <div class="mb-2">

            <div class="location__input animate__animated" :class="{'animate__headShake location__input-error': locationError}">
              <vue-google-autocomplete
                  id="catalogAutocomplete"
                  classname="form-control autocomplete-address"
                  :placeholder="$t('enter_address')"
                  country="fr"
                  ref="catalogAutocomplete"
                  v-on:placechanged="selectAddress">
              </vue-google-autocomplete>
            </div>
            <small v-if="locationError" class="location__input-error-text">{{locationError}}</small>


          </div>
          <span @click="currentPosition" v-if="!isCurrentPositionLoading" class="location__near-me-button" :class="{'text-danger': locationPermissionError}">
            <i class="material-icons notranslate-outlined">near_me</i>
            <span>Utiliser ma position</span>
          </span>

          <div class="location__loading" v-if="isCurrentPositionLoading">
            <ui-progress-circular color="black"></ui-progress-circular>
          </div>

        </form>
      </div>
    </div>

  </nav>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import {mapGetters, mapActions} from 'vuex';
import MobileBanner from "@/mobileComponents/MobileBanner";

export default {
  data() {
    return {
      locationLoading: false,
      locationError: false,
      locationPermissionError: false,
      isNavScrolled: false,
      isCurrentPositionLoading: false
    }
  },
  components: {
    'vue-google-autocomplete': VueGoogleAutocomplete,
    'catalog-mobile-banner': MobileBanner
  },
  methods: {
    ...mapActions(['setCatalogAddressAction', 'parseCatalogAddressAction', 'getUserCurrentPositionAction', 'setHomeAction']),
    search(){
      if(this.isInHomeScreen){
        this.locationError = true;
        document.getElementById('catalogAutocomplete').focus()
        setTimeout(() => {
          this.locationError = false;
        }, 1000)
      }
      else{
        this.$root.$emit('openSearch');
      }
    },
    currentPosition(){
      this.isCurrentPositionLoading = true;
      this.getUserCurrentPositionAction({reload:true})
          .then((address) => {
            document.getElementById('catalogAutocomplete').value = address;
            this.isCurrentPositionLoading = false;
          })
          .catch((error_code) => {
            this.isCurrentPositionLoading = false;
            this.locationPermissionError = this.$t(error_code) + '... ' + this.$t('enter_your_address_for_see_merchants');
          });
    },
    async selectAddress(e){ // Add address by autocomplete
      this.locationLoading = true;
      this.autocompleteData = true;

      if(!e.street_number){
        this.locationError = this.$t('address_no_street_number');
        this.locationLoading = false;
        return;
      }

      await this.setCatalogAddressAction({address: e.street_number + ' ' + e.route, city: e.locality, zip: e.postal_code, country: e.country, lat:e.latitude, lng:e.longitude});
      this.$root.$emit('closeFilterAddress');
      this.locationLoading = false;
    },
    parseAddress(){ // Add address by address value
      const address = document.getElementById('catalogAutocomplete').value;
      if(address === '' || address === null){
        this.locationError = this.$t('address_no_address');
        return;
      }

      this.locationLoading = true;
      setTimeout(() => { // Avoid double send (Autocomplete + server parse)
        if(!this.autocompleteData){ // Send to api server

          this.parseCatalogAddressAction({address: address})
              .then(() => {
                this.$root.$emit('closeFilterAddress');
                this.locationLoading = false;
                this.setHomeAction();
              })
              .catch((error) => {
                this.error = error;
                this.locationLoading = false;
              });
        }
      }, 500);
    },
    scroll(){
      let $filter = document.getElementById('catalogFilter');

      if(this.isInHomeScreen === false && $filter){
        if(document.getElementById('appPage').scrollTop > 50){
          this.isNavScrolled = true;
          $filter.classList.add('catalog-filter-retracted');
        }
        else{
          this.isNavScrolled = false;
          $filter.classList.remove('catalog-filter-retracted');
        }
      }

      document.getElementById('appPage').addEventListener('scroll', (e) => {
        if(!$filter){
          $filter = document.getElementById('catalogFilter');
        }
        if(this.isInHomeScreen === false){
          if(e.target.scrollTop > 50){
            this.isNavScrolled = true;
            $filter.classList.add('catalog-filter-retracted');
          }
          else{
            this.isNavScrolled = false;
            $filter.classList.remove('catalog-filter-retracted');
          }
        }
      })
    }
  },
  computed: {
    ...mapGetters(['isInHomeScreen', 'showMobileDownloadBanner'])
  },
  mounted() {
    this.scroll();
  }
}
</script>
